<template>
  <section class="pdf-content">
    <section class="store-name">
      <span v-text="datas.Store.storeName" />
    </section>
    <section class="order-info-content pt-5">
      <section v-if="datas.paymentStatus == 0" class="order-info">
        <v-icon color="red" v-text="' mdi-cash'" />
        <span v-text="$t('thanks.order_no_paid')" />
      </section>
      <section class="order-info">
        <v-icon v-text="'mdi-clock'" />
        <span
          v-text="
            $appFormatters.formatDateRead(datas.orderExpectedReadyWithExtra)
          "
        />
      </section>
      <section class="order-info">
        <v-icon v-text="' mdi-account-circle'" />
        <span v-text="datas.customerFirstName + ' ' + datas.customerLastName" />
        <span v-text="'#' + datas.publicRef" />
      </section>
      <section class="order-info">
        <v-icon v-text="datas.service.icon" />
        <span v-text="$t('checkout.' + datas.service.serviceName)" />
      </section>
      <section v-if="datas.dropOffDescription" class="order-info">
        <span v-text="datas.dropOffDescription" />
      </section>
      <section class="order-info">
        <v-divider></v-divider>
      </section>
      <section class="order-details">
        <v-container fluid pa-0 ma-0>
          <v-row
            v-for="(item, index) in datas.cart[0].items"
            :key="index"
            class="test_blue pa-0 ma-0"
          >
            <div class="test_yellow mt-2 pa-0 ma-0" style="width: 70%">
              <span v-text="item.quantity + ' X '" />
              <span
                v-text="
                  item.productName +
                  `${
                    item.productVariationName
                      ? ' ( ' + item.productVariationName + ' )'
                      : ''
                  }`
                "
              />
            </div>
            <div style="width: 30%; text-align: right" class="test_green mt-2">
              <span
                v-text="
                  $appFormatters.formatMoney(
                    item.itemTotalPrice,
                    datas.Store.currency
                  )
                "
              />
            </div>
            <div
              v-for="mainAddon in item.groupedAddons"
              :key="mainAddon.id"
              class="test_yellow pa-0 ma-0 pl-3"
              style="width: 100%"
            >
              <span
                class="product-variation"
                v-text="mainAddon.mainAddonName"
              />
              <div
                v-if="mainAddon.subAddons && mainAddon.subAddons.length > 0"
                class="pl-3"
              >
                <p
                  v-for="addon in mainAddon.subAddons"
                  :key="addon.id"
                  class="product-addons-list mb-0"
                  v-text="
                    addon.quantity +
                    ' X ' +
                    addon.addonName +
                    (addon.addonTotalPrice > 0
                      ? ' + ' +
                        $appFormatters.formatMoney(
                          addon.addonTotalPrice,
                          datas.Store.currency
                        )
                      : '')
                  "
                />
              </div>
            </div>
            <!--            <div-->
            <!--              v-if="item.productVariationName"-->
            <!--              class="test_yellow pa-0 ma-0 pl-3"-->
            <!--              style="width: 100%"-->
            <!--            >-->
            <!--              <span v-text="item.productVariationName" />-->
            <!--            </div>-->
            <!--            <div-->
            <!--              v-for="addon in item.addons"-->
            <!--              :key="addon.id"-->
            <!--              class="test_yellow pa-0 ma-0 pl-3"-->
            <!--              style="width: 100%"-->
            <!--            >-->
            <!--              <span v-text="addon.quantity + ' X '" />-->
            <!--              <span v-text="addon.addonName" />-->
            <!--              <span-->
            <!--                v-if="addon.addonTotalPrice > 0"-->
            <!--                v-text="-->
            <!--                  ' + ' +-->
            <!--                  $appFormatters.formatMoney(-->
            <!--                    addon.addonTotalPrice,-->
            <!--                    datas.Store.currency-->
            <!--                  )-->
            <!--                "-->
            <!--              />-->
            <!--            </div>-->
            <div class="test_yellow divider-details mt-2" style="width: 100%">
              <v-divider></v-divider>
            </div>
          </v-row>
          <v-row class="test_blue pa-0 ma-0">
            <div class="test_yellow pa-0 ma-0" style="width: 70%">
              <span v-text="$t('checkout.checkout_extra_bag_cost')" />
            </div>
            <div style="width: 30%; text-align: right" class="test_green">
              <span
                v-text="
                  $appFormatters.formatMoney(
                    datas.Store.configs.extraBagCost,
                    datas.Store.currency
                  )
                "
              />
            </div>
            <div
              v-if="datas.serviceFee === null || datas.serviceFee === 0"
              class="test_yellow divider-details"
              style="width: 100%"
            >
              <v-divider></v-divider>
            </div>
          </v-row>
          <v-row
            v-if="datas.serviceFee !== null || datas.serviceFee > 0"
            class="test_blue pa-0 ma-0"
          >
            <div class="test_yellow pa-0 ma-0" style="width: 70%">
              <span v-text="$t('checkout.serviceFee')" />
            </div>
            <div style="width: 30%; text-align: right" class="test_green">
              <span
                v-text="
                  $appFormatters.formatMoney(
                    datas.serviceFee,
                    datas.Store.currency
                  )
                "
              />
            </div>
            <div class="test_yellow divider-details" style="width: 100%">
              <v-divider></v-divider>
            </div>
          </v-row>
          <v-row
            v-if="datas.service.serviceSlug == 'delivery-service'"
            class="test_blue pa-0 ma-0"
          >
            <div style="width: 100%; text-align: right" class="test_green">
              <span
                v-if="datas.deliveryFee && parseFloat(datas.deliveryFee) > 0.0"
                v-text="
                  $t('general.delivery') +
                  ': ' +
                  $appFormatters.formatMoney(
                    datas.deliveryFee,
                    datas.Store.currency
                  )
                "
              />
              <span
                v-if="
                  datas.deliveryFee && parseFloat(datas.deliveryFee) === 0.0
                "
                v-text="$t('general.delivery') + ': Free'"
              />
            </div>
          </v-row>
          <v-row v-if="datas.offerAmount > 0" class="test_blue pa-0 ma-0">
            <div style="width: 100%; text-align: right" class="test_green">
              <span
                v-text="
                  $t('offers.discount') +
                  ': - ' +
                  $appFormatters.formatMoney(
                    datas.offerAmount,
                    datas.Store.currency
                  )
                "
              />
            </div>
          </v-row>
          <v-row v-if="datas.creditsAmount > 0" class="test_blue pa-0 ma-0">
            <div style="width: 100%; text-align: right" class="test_green">
              <span
                v-text="
                  $t('customerProfile.credits') +
                  ': - ' +
                  $appFormatters.formatMoney(
                    datas.creditsAmount,
                    datas.Store.currency
                  )
                "
              />
            </div>
          </v-row>
          <v-row class="test_blue pa-0 ma-0">
            <div style="width: 100%; text-align: right" class="test_green">
              <span
                v-text="
                  'VAT(' +
                  datas.taxPercent +
                  '%): ' +
                  $appFormatters.formatMoney(
                    datas.taxAmount,
                    datas.Store.currency
                  )
                "
              />
            </div>
          </v-row>
          <v-row class="test_blue pa-0 ma-0">
            <div style="width: 100%; text-align: right" class="test_green">
              <span
                v-text="
                  'Total: ' +
                  $appFormatters.formatMoney(
                    datas.grandTotal,
                    datas.Store.currency
                  )
                "
              />
            </div>
          </v-row>
          <v-row
            v-if="datas.Store.company && datas.Store.company_vat"
            class="test_blue pa-0 ma-0"
          >
            <div style="width: 100%; text-align: right" class="test_green">
              <span
                v-text="
                  datas.Store.company + ' ( ' + datas.Store.company_vat + ' ) '
                "
              />
            </div>
          </v-row>
        </v-container>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: "PdfContent",
  props: {
    datas: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$emit("domRendered");
      }, 1000);
    });
  },
};
</script>

<style lang="scss" scoped>
.pdf-content {
  width: 94%;
  margin: 3%;
}
.order-info-content {
  margin-top: 10px;
}
.order-info {
  font-size: 0.8rem;
  font-weight: 800;
  width: 100%;
  margin: 5px 0;
}
.order-info span {
  margin-left: 5px;
}
.order-details {
  font-size: 0.8rem;
  width: 100%;
  padding: 5px 0 !important;
  margin: 0 !important;
}
.store-name {
  font-size: 1.4rem;
  font-weight: 800;
  width: 100%;
  text-align: center !important;
}
.divider-details {
  padding-top: 1px;
}
</style>
